import { useContext, useMemo } from 'react';
import { useStore } from 'zustand';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { usePackages } from 'app/hooks/data/core/extranet/pack/usePackages';

import { packagesStore } from '../PackageStore';

export const useSelectedPack = () => {
  const { hotelId } = useContext(HotelContext);
  const selectedPackId = useStore(
    packagesStore,
    (state) => state.selectedPackId
  );
  const { data: packages } = usePackages(hotelId);

  return useMemo(
    () => ({
      packages: packages?.packages.find((pack) => pack.id === selectedPackId),
      alwaysIncludedXps: packages?.alwaysIncludedOvernightExperiences,
    }),
    [packages, selectedPackId]
  );
};
